function stringifySearchValue(value: unknown): string {
    if (typeof value === 'object' && value !== null) {
        return JSON.stringify(value)
    }

    if (typeof value === 'string') {
        try {
            JSON.parse(value)
            return JSON.stringify(value)
        } catch {
            // Keep ordinary strings human-readable.
        }
    }

    return String(value)
}

/** Serializes arrays as repeated query parameters instead of JSON blobs. */
export function stringifySearch(search: Record<string, unknown>): string {
    const params = new URLSearchParams()

    for (const [key, value] of Object.entries(search)) {
        if (value === undefined) {
            continue
        }

        if (Array.isArray(value)) {
            for (const item of value) {
                params.append(key, stringifySearchValue(item))
            }
        } else {
            params.set(key, stringifySearchValue(value))
        }
    }

    const query = params.toString().replaceAll('%2C', ',')
    return query ? `?${query}` : ''
}
